export default "__VITE_ASSET__BxMw7JtO__"